import React from 'react'

import { KlarnaOrderOperation } from 'features/account/hm-pay/types'
import PrimaryAction from 'ui/buttons/PrimaryAction'
import SecondaryAction from 'ui/buttons/SecondaryAction'

import { INVOICE_OPERATIONS } from '../../../duck/constants'
import { trackSelectPaymentOption, trackReportReturn } from '../../../tracking'
import styles from './OrderActions.scss'

interface OrderActionsProps {
  orderOperations: KlarnaOrderOperation[]
  runKlarnaOp: (token: string, orderId: string) => void
  orderId: string
}

const OrderActions: React.FC<OrderActionsProps> = ({
  orderOperations = [],
  runKlarnaOp,
  orderId,
}) => {
  const payOperationCTA = (operation: KlarnaOrderOperation): React.ReactNode => (
    <PrimaryAction
      key={operation.type}
      size="large"
      fullWidth
      onClick={() => {
        trackSelectPaymentOption()
        runKlarnaOp(operation.token, orderId)
      }}
    >
      {operation.label}
    </PrimaryAction>
  )

  const defaultOperationCTA = (operation: KlarnaOrderOperation): React.ReactNode => (
    <SecondaryAction
      key={operation.type}
      size="large"
      fullWidth
      onClick={() => {
        if (operation.type === INVOICE_OPERATIONS.REPORT_RETURN) {
          trackReportReturn()
        }
        runKlarnaOp(operation.token, orderId)
      }}
    >
      {operation.label}
    </SecondaryAction>
  )

  return (
    <div className={styles.container}>
      {orderOperations.map((operation) =>
        operation.type === INVOICE_OPERATIONS.PAY
          ? payOperationCTA(operation)
          : defaultOperationCTA(operation),
      )}
    </div>
  )
}

export default OrderActions
